module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-regular.e43b5358.woff2";